<div class="container" [ngStyle]="containerStyles()">
    <canvas #chart>
        <p>{{fallbackText()}}</p>
    </canvas>
</div>
